export class UpdateBillingDetailsModel {
    addressLine1 : string;
    addressLine2 : string;
    postalCode : string;
    city : string;
    country : string;
    phoneNumber : string;
    email : string;
    vatNumber : string;
}